export default "__VITE_ASSET__a1a72073__"